import React, { useEffect, useState } from "react";
import DutiesTable from "./components/DutiesTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Filter from "./modals/Filter";

function Duties(props) {
  const token = useSelector((state) => state.auth.token);
  const [duties, setDuties] = useState([]);
  const [chooseDutyId, setChooseDutyId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDutiesIds, setDeleteDutiesIds] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showFilter, setShowFilter] = React.useState(false);
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    
  
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDuties = (orderBy, sortField, skip, take, filterInputs = {} ) => {
    const {

    name,
    
  } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}duty?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${name ? `&name=${name}` : ""}`)
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setDuties(content);
        setIsError(false);
        setCount(totalElements)

      })
      .catch(() => {
        setIsLoading(false);
        setDuties([]);
        setIsError(true);
      });
  };

  const onDutyChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}duty/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      onDuties(orderBy, sortField, skip, take,filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take,filterInputs]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Vəzifələr</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DutiesTable
        duties={duties}
        isLoading={isLoading}
        isError={isError}
        setChooseDutyId={setChooseDutyId}
        setOpenView={toggleDrawer(true)}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteDutiesIds={setDeleteDutiesIds}
        deleteDutiesIds={deleteDutiesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onDuties={onDuties}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}
        />
      )}

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onDutyChoose={onDutyChoose}
          chooseDutyId={chooseDutyId}
        />
      )}

      {showRemove && (
        <Delete
          id={chooseDutyId}
          show={showRemove}
          onHide={setShowRemove}
          onDuties={onDuties}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}
        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onDuties={onDuties}
         id={chooseDutyId}
          onDutyChoose={onDutyChoose}
         
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
        />
      )}

<Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}

      />
    </div>
  );
}

export default Duties;
